import { createContext } from 'react';

export const ActivitiesContext = createContext({});
